<template>
    <div v-if="show" class="z-10 fixed inset-0 bg-neutral-900	bg-opacity-10">
        
        <div class="h-fit min-h-60 w-96 absolute inset-0 m-auto bg-white border rounded flex flex-col">
            <div class="flex px-3 py-2 border border-b-1 border-t-0 border-x-0	">
                <h1 class="flex-1"> {{ title }} </h1>
                <svg xmlns="http://www.w3.org/2000/svg" fill="black" @click.stop="close"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </div>
            <div class="flex-1 p-5 flex flex-col">
                <div class="flex-1">
                    <span> {{ text }} </span>
                </div>

                <div class="flex">
                    <button :disabled="loading" @click="close"
                    class="cursor-pointer rounded-md mt-6 line-height-5 border mx-1
                    bg-white py-2 px-4 w-full font-weight-bold m-auto ">Cancel</button>

                    <button :disabled="loading" @click="confirmed"
                    class="cursor-pointer text-white rounded-md mt-6 line-height-5 mx-1
                    bg-gray-700 py-2 px-4 w-full font-weight-bold m-auto ">Okay</button>
                </div>
               


            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'PopupMessage',
    props:['title','text','confirmedFun'],
    components: {

    },
    async mounted(){

    },
    data () {
        return {
            show:false,
            query:{},
            loading:false
        }
    }, 
    methods: {
        open:function(query){
            this.show=true;
            if(query){this.query = {...query}}
        },
        close:function(e){
            this.show=false;
        },
        confirmed(){
            this.close();
            this.confirmedFun(this.query)
        }
    }
}
</script>
 
<style>
 
</style>
  


// WEBPACK FOOTER //
// src/components/PopupMessage.vue